import { createTheme } from "@mui/material";

//#region colors
export const trueBlue = "#0265DC";
export const white = "#FFF";
export const black = "#000";
export const strongBlue = "#0366DC";
export const antiFlashWhite = "#F0F4F8";
export const diamond = "#C1E7FE";
export const gray = "#808080";
export const brightGray = "#E9E9E9";
export const limeGreen = "#C1FED3";
export const paleYellow = "#FEFFC0";
export const paleRed = "#FFC0C0";
export const paleViolet = "#E9C0FF";
export const darkGray = "#444746";
export const darkLimeGreen = "#007F02";
export const vividRed = "#EE1A26";
export const strongOrange = "#CF8600";
export const silver = "#DCDCDC";
//#endregion

//#region fonts
export const mainFont = "Inter";
//#endregion

//Default Theme
export const theme = createTheme({
  palette: {
    primary: {
      light: "#e3f2fd",
      main: "rgba(3, 102, 220, 1)",
      dark: "rgba(3, 102, 220, 1)",
    },
    secondary: {
      light: "rgba(255, 255, 255, 0.8)",
      main: "rgba(255, 255, 255, 1)",
      dark: "rgba(255, 255, 255, 1)",
      contrastText: "rgba(0, 0, 0, 1)",
    },
    info: {
      light: "rgba(193, 230, 254, 1)",
      main: "rgba(193, 230, 254, 1)",
      dark: "rgba(193, 230, 254, 1)",
    },
  },
});
